"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAnydayBrand = exports.getBrand = void 0;
var _anyday = _interopRequireDefault(require("../../assets/logos/anyday.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var defaultBrandConfiguration = [{
  name: 'CHANEL',
  id: 'chanel',
  brandRegex: new RegExp(/^CHANEL/),
  titleRegex: new RegExp(/^CHANEL/)
}, {
  name: 'ANYDAY',
  id: 'anyday',
  brandRegex: new RegExp(/(^ANYDAY|^Anyday).*John.*Lewis/),
  titleRegex: new RegExp(/(^ANYDAY|^Anyday)/),
  image: _anyday["default"]
}, {
  name: 'ANYDAY',
  namePrefix: 'John Lewis ',
  id: 'anyday',
  brandRegex: new RegExp(/^anyday|^john lewis anyday/, 'i'),
  titleRegex: new RegExp(/^anyday|^john lewis anyday/, 'i'),
  image: _anyday["default"]
}, {
  name: 'John Lewis & Partners',
  id: 'john-lewis',
  brandRegex: new RegExp(/^john lewis & partners/, 'i'),
  titleRegex: new RegExp(/^john lewis & partners/, 'i')
}, {
  name: 'John Lewis',
  id: 'john-lewis',
  brandRegex: new RegExp(/^john lewis/, 'i'),
  titleRegex: new RegExp(/^john lewis/, 'i')
}];
var getBrand = exports.getBrand = function getBrand(title, customBrandConfiguration) {
  if (!title) return undefined;
  var brandConfiguration = customBrandConfiguration || defaultBrandConfiguration;
  var brandConfig = brandConfiguration.find(function (element) {
    return title.match(element.brandRegex);
  });
  return brandConfig ? {
    id: brandConfig.id,
    name: brandConfig.name,
    namePrefix: brandConfig.namePrefix,
    titleWithoutBrandName: title.replace(brandConfig.titleRegex, ''),
    image: brandConfig.image
  } : undefined;
};
var isAnydayBrand = exports.isAnydayBrand = function isAnydayBrand(brand) {
  return Boolean(brand === null || brand === void 0 ? void 0 : brand.match(new RegExp(/^anyday|^john lewis anyday/, 'i')));
};